// OPLYX mobile bootstrap — Capacitor-only (no-op in web)
// Called once from index.js; handles native splash + status bar + hardware back button.

const isNative = typeof window !== 'undefined' && !!window.Capacitor?.isNativePlatform?.();

export async function initCapacitor() {
  if (!isNative) return; // Web: no-op

  try {
    const { SplashScreen } = await import('@capacitor/splash-screen');
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    const { App } = await import('@capacitor/app');

    // Match the OPLYX dark theme on the status bar
    try {
      await StatusBar.setStyle({ style: Style.Dark });
      await StatusBar.setBackgroundColor({ color: '#0F172A' });
    } catch (e) { /* iOS may not support setBackgroundColor */ }

    // Hide splash once React has mounted
    setTimeout(() => { SplashScreen.hide().catch(() => {}); }, 300);

    // Android hardware back — navigate back if possible, else exit
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack && window.history.length > 1) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });
  } catch (err) {
    // fail-open — plugins not installed yet
    console.warn('[capacitor] init skipped:', err?.message);
  }
}

export function isMobileApp() { return isNative; }
